import { render } from "./AjudaChat.vue?vue&type=template&id=778ae92e&scoped=true"
import script from "./AjudaChat.vue?vue&type=script&lang=js"
export * from "./AjudaChat.vue?vue&type=script&lang=js"

import "./AjudaChat.vue?vue&type=style&index=0&id=778ae92e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778ae92e"]])

export default __exports__